import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ApiResponse } from "src/app/models/apiResponse";
import { PageSizes } from "src/app/models/consts";
import { SearchRequest } from "src/app/models/searchRequest";
import { SearchResponse } from "src/app/models/searchResponse";
import { Video } from "src/app/models/video";
import { ApiService } from "src/app/services/api/api.service";
import { PaginatorService } from "src/app/services/shared/paginator.service";
import { PopupService } from "src/app/services/shared/popup.service";
import { StateService } from "src/app/services/shared/state.service";
import { StaticDataService } from "src/app/services/shared/static.data.service";

@Component({
  selector: "app-videos-affiliate-list",
  templateUrl: "./videos-affiliate-list.component.html",
  styleUrls: ["./videos-affiliate-list.component.scss"],
})
export class VideosAffiliateListComponent implements OnChanges, OnInit {
  pageSizes = PageSizes;
  @Input() resultsPerPage = this.pageSizes[3];
  currentPage = 1;
  totalPages = 0;
  pages: string[] = [];
  isAffiliate: boolean = true;
  videos!: SearchResponse<Video>;

  sortProp = "total";
  orderAsc = false;
  sortingIndex: number = 1;

  contentLoaded: boolean = false;

  @Input() keyword: string = "";
  @Input() affiliateNetworkIds: number[] = [];
  @Input() categoryIds: number[] = [];
  @Input() countryId: number = 0;
  @Input() languageId: string = "";
  @Input() durationId: string = "";
  @Input() videoStatusId: string = "all";

  durationMoreThan: number | undefined = undefined;
  durationLessThan: number | undefined = undefined;

  isPayingUser: boolean = false;

  constructor(
    public apiService: ApiService,
    public popupService: PopupService,
    public stateService: StateService,
    public staticDataService: StaticDataService,
    public route: ActivatedRoute,
    public paginator: PaginatorService
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.contentLoaded = false;
    [this.durationMoreThan, this.durationLessThan] = this.ParseDuration(
      this.durationId
    );
    this.LoadAffiliateVideos();
  }

  ngOnInit(): void {
    this.SubscribeToUser();
  }

  public SubscribeToUser() {
    this.stateService.user$.subscribe((user) => {
      this.isPayingUser = this.stateService.IsPayingUserState(user);
    });
  }

  private async LoadAffiliateVideos() {
    const result = await this.apiService.FullSearchAffiliateVideoAds(
      new SearchRequest(
        this.keyword,
        this.resultsPerPage,
        this.currentPage,
        this.sortProp,
        this.orderAsc,
        this.isAffiliate,
        this.affiliateNetworkIds,
        this.categoryIds,
        this.countryId,
        this.languageId,
        this.durationMoreThan,
        this.durationLessThan,
        this.videoStatusId
      )
    );
    this.ProcessData(result);
  }

  private ProcessData(result: ApiResponse<SearchResponse<Video>> | undefined) {
    if (result?.errorMessage) {
      this.popupService.Notify(result.errorMessage);
      return;
    }

    if (result?.data) {
      this.contentLoaded = true;
      this.videos = result.data;
    }
  }

  public async OnPageSizeChange(value: string) {
    this.currentPage = 1;
    this.resultsPerPage = this.pageSizes.filter((ps) => ps == Number(value))[0];
    await this.LoadAffiliateVideos();
  }

  public async ChangePage(page: number) {
    this.currentPage = page;
    await this.LoadAffiliateVideos();
  }

  public async SetSorting(index: number, sortProp: string, sortOrder: boolean) {
    this.currentPage = 1;
    this.sortingIndex = index;
    this.sortProp = sortProp;
    this.orderAsc = sortOrder;
    await this.LoadAffiliateVideos();
  }

  public OpenVideoInfo(video: Video) {
    this.popupService.openVideoInfoModal(
      video.ytVideoId,
      () => {},
      () => {}
    );
  }

  public OpenVideoBrand(video: Video, event: Event) {
    event.stopPropagation();
    const currentRoute = this.route.snapshot.routeConfig?.path;
    this.popupService.OpenBrandPreview(video.brandId, currentRoute);
  }

  public ParseDuration(duration: string) {
    return duration.split("-").map((str) => {
      return parseInt(str);
    });
  }

  public getBlurIfNeeded(index: number) {
    return {
      filter:
        this.currentPage > 1 && !this.isPayingUser ? "blur(7px)" : "blur(0)",
      "user-select":
        this.currentPage > 1 && !this.isPayingUser ? "none" : "auto",
      "pointer-events":
        this.currentPage > 1 && !this.isPayingUser ? "none" : "auto",
    };
  }
}
